module.exports = __webpack_public_path__ + "static/assets/e19206ff23cd451c429bf14dd1ebe421.png";